<template>
  <div>
    <p class="headline" v-html="$t('tutorial.stepTracta.TITLE')"></p>
    <p class="subheading" style="text-align: justify" v-html="$t('tutorial.stepTracta.BODY')"></p>
    <v-expansion-panel expand>
      <v-expansion-panel-content v-for="(item, i) in $t('info.scopes', version)" :key="i">
        <div slot="header" v-html="item.TITLE"></div>
        <v-card>
          <v-card-text style="text-align: justify" class="grey lighten-3" v-html="item.EXPLANATION"></v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-container>
      <v-layout>
        <v-btn @click.native="$emit('back')" flat>{{ $t('tutorial.buttons.BACK') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="$emit('continue')">{{ $t('tutorial.buttons.CONTINUE') }}</v-btn>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'tutorial-step4',
    data: function () {
      return {
        version: this.$auth.user().version
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialStep4.vue